/* Deal strip — ported from the prototype's dealstrip(). Logo initials, name,
   meta line and a "Step N · Name" chip for the current workspace step. */
import React from 'react';

import { initialsOf, stepMeta } from '../helpers';

export default function DealStrip({ deal, stepId }) {
	const d = deal.detail || {};
	const scores = d.analysisScore ? ` · analysis ${d.analysisScore}/100 · triage ${d.triageScore}/10` : '';
	const { num, name } = stepMeta(stepId || 'intake');
	return (
		<div className="dealstrip">
			<span className="dealstrip__logo">{initialsOf(deal.name)}</span>
			<div>
				<div className="dealstrip__name">{deal.name}</div>
				<div className="dealstrip__meta">
					{(d.round || '')}{d.round ? ' · ' : ''}{deal.sector} · Ask {deal.ask}{d.equity ? ` for ${d.equity}` : ''}{scores}
				</div>
			</div>
			<span className="chip chip--blue" style={{ marginLeft: 'auto' }}>Step {num} · {name}</span>
		</div>
	);
}
